import { ProductRecommendationSchema } from 'utils/eva';
import { z } from 'zod';


export const MessageSchema = z.object({
  id: z.string(),
  isUser: z.boolean(),
  text: z.string(),
  recommendations: ProductRecommendationSchema.optional(),
});

export const BubbleVariantSchema = z.enum(['page', 'widget']);

export const ChatStatusSchema = z.enum([
  'idle',
  'connecting',
  'connected',
  'sending',
  'error',
]);

export const ChatMachineStateSchema = z.object({
  status: ChatStatusSchema,
  inputValue: z.string(),
  messages: z.array(MessageSchema),
  errorMessage: z.string().nullable(),
  isThinking: z.boolean(),
  isStreaming: z.boolean(),
  activeAgentMessageId: z.string().nullable(),
  activeStreamEventSeq: z.number(),
});

export const ChatMachineActionSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('SET_INPUT'), value: z.string() }),
  z.object({ type: z.literal('CONNECTING') }),
  z.object({ type: z.literal('CONNECTED') }),
  z.object({ type: z.literal('CONNECT_FAILED'), errorMessage: z.string() }),
  z.object({
    type: z.literal('USER_MESSAGE_SENT'),
    id: z.string(),
    text: z.string(),
  }),
  z.object({
    type: z.literal('AGENT_MESSAGE_RECEIVED'),
    id: z.string(),
    text: z.string(),
  }),
  z.object({
    type: z.literal('AGENT_MESSAGE_STREAMED'),
    id: z.string(),
    text: z.string(),
  }),
  z.object({
    type: z.literal('AGENT_STREAM_COMPLETE'),
    id: z.string(),
  }),
  z.object({
    type: z.literal('ATTACH_RECOMMENDATIONS'),
    id: z.string(),
    recommendations: ProductRecommendationSchema,
  }),
  z.object({ type: z.literal('SET_THINKING'), isThinking: z.boolean() }),
  z.object({ type: z.literal('ERROR'), errorMessage: z.string() }),
  z.object({ type: z.literal('CLEAR_ERROR') }),
  z.object({ type: z.literal('RESET') }),
]);

export const ConversationStartSessionArgsSchema = z.object({
  agentId: z.string(),
  connectionType: z.literal('websocket'),
  textOnly: z.literal(true),
});

export const ElevenLabsMessageSchema = z
  .object({
    type: z.string().optional(),
    source: z.string().optional(),
    message: z.string().optional(),
    text: z.string().optional(),
  })
  .passthrough();

export const ElevenLabsTextResponsePartSchema = z.object({
  type: z.enum(['start', 'delta', 'stop']),
  text: z.string(),
});
